import { Chip } from "@mui/material";
import { Datagrid, DateField, FunctionField, List, TextField, useRecordContext } from "react-admin";

import { PAYOUT_METHOD_LABEL, payoutStatus } from "../partners/status";

export type PayoutRecord = {
  id: string;
  reference: string;
  partner_id: string;
  partner_phone: string | null;
  method: string;
  destination: Record<string, string>;
  amount_usd: number;
  fee_usd: number;
  net_usd: number;
  rate: number | null;
  amount_rub: number | null;
  status: string;
  reject_reason: string | null;
  tx_hash: string | null;
};

function StatusChip() {
  const record = useRecordContext<PayoutRecord>();
  if (!record) return null;
  const s = payoutStatus(record.status);
  return <Chip size="small" color={s.color} label={s.label} />;
}

export function PartnerPayoutList() {
  return (
    <List perPage={50} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="reference" label="Заявка" />
        <FunctionField label="Статус" render={() => <StatusChip />} />
        <TextField source="partner_phone" label="Партнёр" />
        <FunctionField
          label="Способ"
          render={(r: PayoutRecord) => PAYOUT_METHOD_LABEL[r.method] ?? r.method}
        />
        <FunctionField label="К выплате" render={(r: PayoutRecord) => `${Number(r.net_usd).toFixed(2)} $`} />
        <DateField source="created_at" label="Создана" showTime />
      </Datagrid>
    </List>
  );
}
